const enterprisesApi = ({ apiClient }) => ({
  list(params, headers = {}) {
    return apiClient.get('enterprises', {}, params, headers)
  },
  show(id) {
    return apiClient.get(`enterprises/${id}`, {}, {}, {})
  },
  amenities(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/amenities`, {}, params, headers)
  },

  building(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/building`, {}, params, headers)
  },

  addresses(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/addresses`, {}, params, headers)
  },

  metadata(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/metadata`, {}, params, headers)
  },

  amenityGroups(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/amenity-groups`, {}, params, headers)
  },

  referencePoints(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/reference-points`, {}, params, headers)
  },

  condominium(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/condominium`, {}, params, headers)
  },

  condominiumAmenityGroups(id, params = {}, headers = {}) {
    return apiClient.get(`enterprises/${id}/condominium/amenity-groups`, {}, params, headers)
  },

  photos: {
    listByIds(params = {}, headers = {}) {
      return apiClient.get('enterprises/photos', {}, params, headers)
    },

    list(enterpriseId, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/photos`, {}, params, headers)
    },

    listByType(enterpriseId, type, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/photos/type/${type}`, {}, params, headers)
    },

    show(enterpriseId, photoId, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/photos/${photoId}`, {}, params, headers)
    },

    store(enterpriseId, payload, headers = {}) {
      return apiClient.post(`enterprises/${enterpriseId}/photos`, payload, false, headers)
    },

    update(enterpriseId, photoId, payload, headers = {}) {
      return apiClient.put(`enterprises/${enterpriseId}/photos/${photoId}`, payload, headers)
    },

    patch(enterpriseId, photoId, payload, headers = {}) {
      return apiClient.patch(`enterprises/${enterpriseId}/photos/${photoId}`, payload, headers)
    },

    delete(enterpriseId, photoId, headers = {}) {
      return apiClient.delete(`enterprises/${enterpriseId}/photos/${photoId}`, headers)
    },
  },

  videos: {
    list(enterpriseId, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/videos`, {}, params, headers)
    },

    listByType(enterpriseId, type, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/videos/type/${type}`, {}, params, headers)
    },

    show(enterpriseId, videoId, params = {}, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/videos/${videoId}`, {}, params, headers)
    },

    store(enterpriseId, payload, headers = {}) {
      return apiClient.post(`enterprises/${enterpriseId}/videos`, payload, false, headers)
    },

    update(enterpriseId, videoId, payload, headers = {}) {
      return apiClient.put(`enterprises/${enterpriseId}/videos/${videoId}`, payload, headers)
    },

    patch(enterpriseId, videoId, payload, headers = {}) {
      return apiClient.patch(`enterprises/${enterpriseId}/videos/${videoId}`, payload, headers)
    },

    delete(enterpriseId, videoId, headers = {}) {
      return apiClient.delete(`enterprises/${enterpriseId}/videos/${videoId}`, headers)
    },
  },

  store(payload) {
    return apiClient.post('enterprises', payload, false, {})
  },
  duplicate(id, headers = {}) {
    return apiClient.post(`enterprises/${id}/duplicate`, {}, false, headers)
  },
  update(id, payload) {
    return apiClient.put(`enterprises/${id}`, payload, {})
  },
  updatePosition(payload, params, headers = {}) {
    return apiClient.put('enterprises/position', payload, params, headers)
  },
  delete(id, headers = {}) {
    return apiClient.delete(`enterprises/${id}`, headers)
  },
  search(params, headers = {}) {
    return apiClient.get('enterprises/', {}, params, headers)
  },

  // Unit Groups endpoints
  unitGroups: {
    list(enterpriseId, headers = {}) {
      return apiClient.get(`enterprises/${enterpriseId}/unit-groups`, {}, {}, headers)
    },
    
    store(enterpriseId, payload, headers = {}) {
      return apiClient.post(`enterprises/${enterpriseId}/unit-groups`, payload, false, headers)
    },
    
    update(enterpriseId, groupId, payload, headers = {}) {
      return apiClient.put(`enterprises/${enterpriseId}/unit-groups/${groupId}`, payload, headers)
    },
    
    delete(enterpriseId, groupId, params = {}, headers = {}) {
      return apiClient.delete(`enterprises/${enterpriseId}/unit-groups/${groupId}`, headers, params)
    },
    
    reorder(enterpriseId, payload, headers = {}) {
      return apiClient.post(`enterprises/${enterpriseId}/unit-groups/reorder`, payload, false, headers)
    }
  }
})

export default enterprisesApi
